/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFileResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, type FileResponse, type HttpValidationProblemDetails, type IError } from '../../../models/index.js';
// @ts-ignore
import { DownloadRequestBuilderRequestsMetadata, type DownloadRequestBuilder } from './download/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /shares/files/{token}
 */
export interface WithTokenItemRequestBuilder extends BaseRequestBuilder<WithTokenItemRequestBuilder> {
    /**
     * The download property
     */
    get download(): DownloadRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FileResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FileResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithTokenItemRequestBuilderUriTemplate = "{+baseurl}/shares/files/{token}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithTokenItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithTokenItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    download: {
        requestsMetadata: DownloadRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithTokenItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithTokenItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFileResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
